var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagCn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 0H0V10H14.9998V0Z",
    fill: "#D80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24176 3.05376L5.67113 4.37524H7.06063L5.9365 5.19197L6.3659 6.5135L5.24176 5.69675L4.11762 6.5135L4.54699 5.19197L3.42285 4.37524H4.81236L5.24176 3.05376Z",
    fill: "#FFDA44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94814 7.449L7.52656 7.1427L7.10505 7.44897L7.26603 6.95345L6.84448 6.64715H7.36555L7.52656 6.15157L7.68764 6.64715H8.20868L7.78713 6.95342L7.94814 7.449Z",
    fill: "#FFDA44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04776 5.93537H8.52672L8.36571 6.43089L8.20469 5.9354L7.68359 5.93537L8.1052 5.62907L7.94413 5.13352L8.36571 5.43976L8.78725 5.13352L8.62624 5.62907L9.04776 5.93537Z",
    fill: "#FFDA44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04776 4.06437L8.62624 4.37066L8.78722 4.86618L8.36571 4.55995L7.94413 4.86624L8.1052 4.37063L7.68359 4.06443L8.20472 4.06437L8.36571 3.56879L8.52672 4.06437H9.04776Z",
    fill: "#FFDA44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94811 2.55073L7.78713 3.04632L8.20865 3.35255L7.68761 3.35258L7.52654 3.84819L7.36552 3.35255L6.84448 3.35261L7.26603 3.04629L7.10502 2.5507L7.52654 2.857L7.94811 2.55073Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCn);
export default __webpack_public_path__ + "static/media/flag_cn.ad54f68d3fd78f38829907cfe4c08870.svg";
export { ForwardRef as ReactComponent };